<template>
  <div class='about'>
    <div class="banner">
      <p>关于我们</p>
      <p>让你更安心、更放心、更省心</p>
    </div>

    <div class="content head">
      <div class="ens">about us</div>
      <div class="chs">
        <span>关于我们</span>
        <el-divider class="divider"></el-divider>
      </div>
      <div class="desc">
        <p>广州甘苗信息科技有限公司成立于2018年11月23日，注册地位于广州市天河区华利路2号406房(仅限办公)，</p>
        <p>法定代表人为裘农。经营范围包括机器人系统技术服务;科技信息咨询服务;</p>
        <p>教育咨询服务;网络技术的研究、开发;</p>
        <p>信息技术咨询服务;软件批发;软件开发;软件服务;软件测试服务;计算机技术开发、技术服务;</p>
        <p>计算机硬件的研究、开发;机器人系统生产;机器人销售;智能机器销售;</p>
        <p>人工智能算法软件的技术开发与技术服务;</p>
        <p>网络信息技术推广服务;计算机技术转让服务。</p>
      </div>
    </div>
    <div class="fill"></div>
    <div class="contact head">
      <div class="ens">contact us</div>
      <div class="chs">
        <span>联系我们</span>
        <el-divider class="divider"></el-divider>
      </div>
      <div class="email">
        <img :src="require('@/assets/phone.png')" width="36" height="36" />
        <div class="text">
          <p>联系电话：</p>
          <p>18145709897</p>
        </div>
      </div>
      <div class="tel">
        <img :src="require('@/assets/email.png')" width="36" height="36" />
        <div class="text">
          <p>E-mail：</p>
          <p>huahua@gzgmjykjyxgs.wecom.work</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {

    }
  },
  created () {
  },
  methods: {
  },
}
</script>

<style scoped lang='less'>
.about {
  min-height: calc(100vh - 61px - 150px);
  .banner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 374px;
    color: #fff;
    text-align: center;
    background: url('../assets/about.png') no-repeat;
    background-size: cover;
    margin-bottom: 120px;
    p:first-child {
      font-size: 42px;
    }
    p:last-child {
      font-size: 30px;
    }
  }
  .head {
    width: 1344px;
    margin: 0 auto 65px;
    .ens {
      color: #000;
      font-size: 34px;
      margin-bottom: 12px;
      text-transform: uppercase;
    }
    .chs {
      display: flex;
      justify-content: space-between;
      color: #db1b1b;
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 30px;
      .divider {
        width: 1200px;
        height: 3px;
        background-color: #b2b2b2;
      }
    }
  }
  .content {
    .desc {
      width: 980px;
      font-size: 20px;
      line-height: 36px;
      margin: 0 auto;
      text-align: center;
    }
  }
  .fill {
    width: 1344px;
    height: 252px;
    margin: 0 auto 130px;
    background: url('../assets/sw.png') no-repeat;
    background-size: cover;
  }
  .contact {
    .email,
    .tel {
      display: flex;
      width: 1200px;
      color: #666666;
      font-size: 23px;
      font-weight: bold;
      margin: 0 auto 50px;
      img {
        margin-right: 50px;
      }
      p {
        margin-bottom: 12px;
      }
    }
    .email {
      margin-top: 100px;
    }
  }
}
</style>
